export default __webpack_public_path__ + "static/media/Cart DNA.8fd95b8c.png";